import script from "./GoalGroupDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./GoalGroupDetail.vue?vue&type=script&setup=true&lang=js"

import "./GoalGroupDetail.vue?vue&type=style&index=0&id=4d3e5276&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d3e5276"]])

export default __exports__